import React from 'react'

import RegisterTeam from '../Common/RegisterTeam'

export default function RegisterEmployee() {
    return (
       
                        <RegisterTeam logoClass='text-center' />
             
    )
}